import {useParams} from 'react-router-dom';
import React, {useEffect, useState} from "react";
import api from "../../api";
import IranFlag from "../../assets/images/iran.webp";
import {toast, ToastContainer} from "react-toastify";
import {p2e, e2p} from "../../utils/utils";
import {FaTrash} from "react-icons/fa";
import {Dialog, DialogContent, DialogContentText, DialogTitle} from "@material-ui/core";
import {createTheme, ThemeProvider} from "@mui/material";

const theme = createTheme({
    palette: {
        primary: {
            main: '#ffe052'
        },
    },
    
});

export default function EditReport(props) {
    const [car, setCar] = useState(null);
    const [editingData, setEditingData] = useState({
        plateFirst: '',
        plateLetter: '',
        plateSecond: '',
        plateThird: '',
        mobile_number: '',
        name: '',
        lastname: '',
        description: '',
        discount: 0,
        amount_of_fuel: null,
        kilometerage: null,
    });
    const [carSmoothers, setCarSmoothers] = useState([]);
    const [painters, setPainters] = useState([]);
    const [selectedSmoother, setSelectedSmoother] = useState(null);
    const [selectedPainter, setSelectedPainter] = useState(null);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    
    const {requestId} = useParams();
    const {carId} = useParams();
    
    useEffect(() => {
        const fetchCar = async () => {
            await api.get(`/car/${carId}`)
                .then(carResponse => {
                        api.get(`/repair-request/${requestId}`)
                            .then(reportResponse => {
                                const carData = carResponse.data.data
                                const reportData = reportResponse.data.data;
                                setCar(carData);
                                setEditingData({
                                    plateFirst: carData.plate.slice(0, 2),
                                    plateLetter: carData.plate.slice(2, 3),
                                    plateSecond: carData.plate.slice(3, 6),
                                    plateThird: carData.plate.slice(7, 9),
                                    mobile_number: carData.car_owner.mobile_number,
                                    name: carData.car_owner.name,
                                    lastname: carData.car_owner.lastname,
                                    description: reportData.description,
                                    discount: reportData.discount,
                                    amount_of_fuel: reportData.amount_of_fuel,
                                    kilometerage: reportData.kilometerage,
                                });
                                
                                setSelectedSmoother(
                                    reportData.worker_repair_request.filter(worker => worker.type === "1")[0]?.worker.id ?? null
                                );
                                setSelectedPainter(
                                    reportData.worker_repair_request.filter(worker => worker.type === "2")[0]?.worker.id ?? null
                                );
                            })
                            .catch(error => {
                                console.log(error)
                                toast.error(error.response.data.message)
                            });
                    }
                ).catch(error => {
                    console.log(error)
                    toast.error(error.response.data.message)
                });
        }
        fetchCar();
        
        const fetchSmoothers = async () => {
            try {
                const response = await api.get('/worker?type=1');
                setCarSmoothers(response.data.data);
            } catch (error) {
                toast.error(error.response.data.message)
            }
        };
        fetchSmoothers();
        
        const fetchReportWorkers = async () => {
            try {
                const response = await api.get(`/repair-request/${requestId}`);
                response.data.data.worker_repair_request.map(worker => {
                    if (worker.type === "1") {
                        setSelectedSmoother(worker.worker)
                    } else {
                        setSelectedPainter(worker.worker)
                    }
                })
            } catch (error) {
                toast.error(error.response.data.message)
            }
        };
        fetchReportWorkers();
        const fetchPainters = async () => {
            try {
                const response = await api.get('/worker?type=2');
                setPainters(response.data.data);
            } catch (error) {
                toast.error(error.response.data.message)
            }
        };
        fetchPainters();
    }, []);
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!parseInt(p2e(editingData.mobile_number.toString())) && editingData.mobile_number !== '') {
            toast.error('فرمت تلفن همراه اشتباه است.');
            return;
        }
        if (!parseInt(p2e(editingData.kilometerage.toString())) && editingData.kilometerage !== '') {
            toast.error('فرمت کیلومتر اشتباه است.');
            return;
        }
        if (!parseInt(p2e(editingData.discount.toString())) && editingData.discount !== 0) {
            toast.error('فرمت تخفیف اشتباه است.');
            return;
        }
        
        try {
            const reportData = {
                description: editingData.description,
                discount: p2e(editingData.discount.toString()),
                amount_of_fuel: editingData.amount_of_fuel,
                kilometerage: p2e(editingData.kilometerage.toString()),
            };
            
            await api.post(`/repair-request/${requestId}`, reportData);
            
            const carOwnerData = {
                name: editingData.name,
                lastname: editingData.lastname,
                mobile_number: p2e(editingData.mobile_number)
            };
            await api.post(`/car-owner/${car.car_owner_id}`, carOwnerData);
            
            const carData = {
                'plate': `${editingData.plateFirst}${editingData.plateLetter}${editingData.plateSecond} ${editingData.plateThird}`
            };
            
            await api.post(`/car/${car.id}`, carData);
            
            const smootherRequestData = {
                'worker_id': parseInt(selectedSmoother),
                'type': 1
            };
            await api.post(`/repair-request/worker/${requestId}`, smootherRequestData);
            
            const painterRequestData = {
                'worker_id': parseInt(selectedPainter),
                'type': 2
            };
            await api.post(`/repair-request/worker/${requestId}`, painterRequestData);
            
            
            toast.success('ویرایش با موفقیت انجام شد.');
            
        } catch (err) {
            toast.error(err.response?.data?.message || 'خطایی رخ داده است.');
            console.log(err)
        }
    };
    
    const handleDelete = async () => {
        console.log(carId)
        try {
            await api.delete(`/car/${carId}`);
            toast.success('ماشین با موفقیت حذف شد.');
            setOpenDeleteDialog(false);
            setTimeout(() => window.location.href = '/reports', 1500);
            
        } catch (err) {
            toast.error(err.response?.data?.message || 'خطایی رخ داده است.');
            console.log(err)
        }
    }
    
    return (
        <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                {car &&
                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 col-xxl-6">
                            <div className="card rounded-4 border-3 border-dark mb-4">
                                <h5 className="card-header bg-dark text-white text-center">ویرایش اطلاعات</h5>
                                <div className="card-body">
                                    <button className="btn btn-danger mx-1"
                                            onClick={() => setOpenDeleteDialog(true)}
                                    >
                                        <FaTrash size={20} className="text-white my-auto"/>
                                    </button>
                                    <form onSubmit={handleSubmit}>
                                        <div className="row mx-auto pelak g-0 mb-3 mt-3" style={{width: '20rem'}}>
                                            <div className="col">
                                                <div className="row g-0">
                                                    <div className="col border-start border-end-0">
                                                        <p className="text-center m-0 fw-bold iranNo">ایران</p>
                                                        <div>
                                                            <input
                                                                className="border-0 text-center"
                                                                type="text"
                                                                onInput={(e) => e.target.value = e.target.value.slice(0, 2)}
                                                                value={editingData.plateThird}
                                                                onChange={(e) => {
                                                                    setEditingData({
                                                                        ...editingData,
                                                                        plateThird: e.target.value
                                                                    });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <input
                                                            className="border-0 text-center"
                                                            type="text"
                                                            onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                                            value={editingData.plateSecond}
                                                            onChange={(e) => {
                                                                setEditingData({
                                                                    ...editingData,
                                                                    plateSecond: e.target.value
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col">
                                                        <input
                                                            className="border-0 text-center"
                                                            type="text"
                                                            maxLength="1"
                                                            value={editingData.plateLetter}
                                                            onChange={(e) => {
                                                                setEditingData({
                                                                    ...editingData,
                                                                    plateLetter: e.target.value
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col">
                                                        <input
                                                            className="border-0 text-center"
                                                            type="text"
                                                            id="inputPelak"
                                                            onInput={(e) => e.target.value = e.target.value.slice(0, 2)}
                                                            value={editingData.plateFirst}
                                                            onChange={(e) => {
                                                                setEditingData({
                                                                    ...editingData,
                                                                    plateFirst: e.target.value
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-auto leftSide">
                                                <div className="flag">
                                                    <img src={IranFlag} alt="iran's flag"/>
                                                </div>
                                                <div className="iranText text-center">
                                                    <p>I.R.</p>
                                                    <p>IRAN</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='mb-3'>
                                            <label htmlFor="mobileNumber" className="form-label">تلفن همراه</label>
                                            <input
                                                className="form-control shadow"
                                                type='text'
                                                maxLength={11}
                                                id="mobileNumber"
                                                value={e2p(editingData.mobile_number)}
                                                onChange={(e) => {
                                                    setEditingData({...editingData, mobile_number: e.target.value})
                                                }}
                                            />
                                        </div>
                                        <div className='mb-3'>
                                            <label className="form-label">نام مالک</label>
                                            <input
                                                className="form-control shadow"
                                                type="text"
                                                value={editingData.name}
                                                onChange={(e) => {
                                                    setEditingData({...editingData, name: e.target.value})
                                                }}/>
                                            <input
                                                className="form-control shadow"
                                                type="text"
                                                value={editingData.lastname}
                                                onChange={(e) => {
                                                    setEditingData({...editingData, lastname: e.target.value})
                                                }}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="smoother-id" className="form-label">صافکار</label>
                                            <select
                                                id="smoother-id"
                                                value={selectedSmoother}
                                                onChange={(event) => {
                                                    setSelectedSmoother(event.target.value);
                                                }}
                                                className="form-select shadow"
                                            >
                                                <option value={null}>-- انتخاب صافکار --</option>
                                                {carSmoothers.map((smoother) => (
                                                    <option key={smoother.id} value={smoother.id}>
                                                        {smoother.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        
                                        <div className="mb-3">
                                            <label htmlFor="painter-id" className="form-label">نقاش</label>
                                            <select
                                                id="painter-id"
                                                value={selectedPainter}
                                                onChange={(event) => {
                                                    setSelectedPainter(event.target.value);
                                                }}
                                                className="form-select shadow"
                                            >
                                                <option value={null}>-- انتخاب نقاش --</option>
                                                {painters.map((painter) => (
                                                    <option key={painter.id} value={painter.id}>
                                                        {painter.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="kilometerage" className="form-label">کیلومتر</label>
                                            <input
                                                required
                                                type='integer'
                                                maxLength={15}
                                                className="form-control shadow"
                                                id="kilometerage"
                                                name="kilometerage"
                                                value={e2p(editingData.kilometerage.toString())}
                                                onChange={(e) => {
                                                    setEditingData({...editingData, kilometerage: e.target.value});
                                                }}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="amount_of_fuel" className="form-label">میزان سوخت</label>
                                            <select
                                                required
                                                id="amount_of_fuel"
                                                className="form-select shadow"
                                                name="amount_of_fuel"
                                                value={editingData.amount_of_fuel}
                                                onChange={(e) => {
                                                    setEditingData({...editingData, amount_of_fuel: e.target.value});
                                                }}
                                            >
                                                <option>--انتخاب کنید--</option>
                                                <option value="پر">پر</option>
                                                <option value="سه چهارم">سه چهارم</option>
                                                <option value="نصف">نصف</option>
                                                <option value="یک چهارم">یک چهارم</option>
                                                <option value="خالی">خالی</option>
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="discount" className="form-label">تخفیف</label>
                                            <input
                                                required
                                                type='text'
                                                maxLength={15}
                                                className="form-control shadow"
                                                id="discount"
                                                name="discount"
                                                value={e2p(editingData.discount.toString())}
                                                onChange={(e) => {
                                                    setEditingData({...editingData, discount: e.target.value});
                                                }}
                                            />
                                        </div>
                                        <div className='mb-3'>
                                            <label htmlFor="description" className="form-label">توضیحات</label>
                                            <textarea
                                                className="form-control shadow"
                                                id="description"
                                                value={editingData.description}
                                                onChange={(e) => {
                                                    setEditingData({...editingData, description: e.target.value});
                                                }}></textarea>
                                        </div>
                                        <div className='d-grid gap-2'>
                                            <input type="submit" className="btn btn-warning" name="submit"
                                                   value="اعمال تغییرات"/>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
            <ThemeProvider theme={theme}>
                <Dialog className="text-center" open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
                    <DialogTitle className="bg-dark">
                        <p className="text-white">حذف صافکاری</p>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            آیا مطمئن هستید که میخواهید صافکاری را حذف کنید ؟
                        </DialogContentText>
                    </DialogContent>
                    <button className='btn btn-danger mx-5 mb-2 mt-3'
                           onClick={() => handleDelete()}
                    >
                        حذف
                    </button>
                    <button className='btn btn-secondary mx-5 mb-2'
                           onClick={() => setOpenDeleteDialog(false)}
                    >
                        انصراف
                    </button>
                </Dialog>
            </ThemeProvider>
        </div>
    )
}
